<nb-card class="content-view">
  <nb-card-header>
    <span>Chọn hình ảnh</span>

    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <ngx-upload-image
      [type]="'multiple'"
      [mode]="mode"
      [path]="path"
      (onSelectSuccess)="selectedImage($event)"
      (onUploadSuccess)="uploadImage($event)"
    ></ngx-upload-image>
  </nb-card-body>
</nb-card>
